import React from "react";
import Container from "./Container";

const Office = () => {
  return (
    <div className="office">
      <Container>
        <h2>O ESCRITÓRIO</h2>

        <p>
          Fundado no ano de 1976 por Francismar Sanches Lopes; no ano de 2002, transformou-se em
          sociedade de advogados, adentrando à sociedade o sócio advogado Luciano de Sales, surgindo
          a Sanches Lopes, Sales &amp; Advogados Associados.
        </p>
        <p>
          A partir de 2004, a SLS Advogados Associados passou a dar ênfase no projeto de consultoria
          de Advocacia Preventiva; No ano de 2010, a Sociedade Advocatícia consolidou o número de 07
          (sete) profissionais especializados em sua equipe, inovando ainda mais a forma preventiva
          de atuação para as empresas, associações e cooperativas clientes.
        </p>
        <p>
          Em 2013, alcançou a meta estabelecida no projeto de Consultoria e Advocacia Preventiva de
          empresas fidelizadas; atualmente, vem investindo na capacitação tecnológica de toda sua
          equipe, bem como na informatização de sistemas, ampliação das instalações, contratação de
          novos profissionais, tendo em vista a expansão da carteira de clientes.
        </p>
        <p>
          Em 2016 iniciou a Consultoria de Gestão de Qualidade; Em 2018 foi certificado pela ABNT
          ISO 9001.
        </p>

        <h3>MISSÃO</h3>

        <p>
          Apresentar aos nossos clientes orientações com alternativas jurídicas adequadas e seguras
          no âmbito de seus interesses, atendendo suas necessidades com qualidade e eficiência na
          prestação dos nossos serviços.
        </p>

        <h3>VISÃO</h3>

        <p>
          Ser reconhecida onde estiver pela defesa dos interesses dos nossos clientes, demonstrando
          segurança e solidez na atuação da equipe, tornando-se referência para sociedade.
        </p>

        <h3>COMPROMISSO SOCIAL</h3>

        <p>
          Resgatar a grandeza da Advocacia, auxiliando diuturnamente na formação educacional dos
          direitos e deveres do cidadão brasileiro. Apoiar e auxiliar intelectual e culturalmente,
          de forma irrestrita, projetos sociais com intuito de evitar a marginalização das crianças
          e adolescentes de nosso município.
        </p>
      </Container>
    </div>
  );
};

export default Office;
